import Home from './Home';
import BrandingLogos from './BrandingLogos';
import LoggedOut from './LoggedOut';

export default {
  Home,
  LoggedOut,
  BrandingLogos
}